import { render, staticRenderFns } from "./newCampaign.vue?vue&type=template&id=5118a512&scoped=true&"
import script from "./newCampaign.vue?vue&type=script&lang=js&"
export * from "./newCampaign.vue?vue&type=script&lang=js&"
import style0 from "./newCampaign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newCampaign.vue?vue&type=style&index=1&id=5118a512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118a512",
  null
  
)

export default component.exports